module.exports = __webpack_public_path__ + "static/media/015.b3414fac.jpg";